(function () {
var $83fe5eb4ecf39302$exports = {};
const $83fe5eb4ecf39302$var$account1 = {
    owner: "Jonas Schmedtmann",
    movements: [
        200,
        455.23,
        -306.5,
        25000,
        -642.21,
        -133.9,
        79.97,
        1300
    ],
    interestRate: 1.2,
    pin: 1111,
    movementsDates: [
        "2019-11-18T21:31:17.178Z",
        "2019-12-23T07:42:02.383Z",
        "2020-01-28T09:15:04.904Z",
        "2020-04-01T10:17:24.185Z",
        "2020-05-08T14:11:59.604Z",
        "2020-05-27T17:01:17.194Z",
        "2023-08-26T12:01:20.894Z",
        "2023-08-28T12:01:20.894Z"
    ],
    currency: "EUR",
    locale: "pt-PT"
};
const $83fe5eb4ecf39302$var$account2 = {
    owner: "Jessica Davis",
    movements: [
        5000,
        3400,
        -150,
        -790,
        -3210,
        -1000,
        8500,
        -30
    ],
    interestRate: 1.5,
    pin: 2222,
    movementsDates: [
        "2019-11-01T13:15:33.035Z",
        "2019-11-30T09:48:16.867Z",
        "2019-12-25T06:04:23.907Z",
        "2020-01-25T14:18:46.235Z",
        "2020-02-05T16:33:06.386Z",
        "2020-04-10T14:43:26.374Z",
        "2023-08-26T12:01:20.894Z",
        "2023-08-28T12:01:20.894Z"
    ],
    currency: "USD",
    locale: "en-US"
};
const $83fe5eb4ecf39302$var$accounts = [
    $83fe5eb4ecf39302$var$account1,
    $83fe5eb4ecf39302$var$account2
];
/////////////////////////////////////////////////
// Elements
const $83fe5eb4ecf39302$var$labelWelcome = document.querySelector(".welcome");
const $83fe5eb4ecf39302$var$labelDate = document.querySelector(".date");
const $83fe5eb4ecf39302$var$labelBalance = document.querySelector(".balance__value");
const $83fe5eb4ecf39302$var$labelSumIn = document.querySelector(".summary__value--in");
const $83fe5eb4ecf39302$var$labelSumOut = document.querySelector(".summary__value--out");
const $83fe5eb4ecf39302$var$labelSumInterest = document.querySelector(".summary__value--interest");
const $83fe5eb4ecf39302$var$labelTimer = document.querySelector(".timer");
const $83fe5eb4ecf39302$var$containerApp = document.querySelector(".app");
const $83fe5eb4ecf39302$var$containerMovements = document.querySelector(".movements");
const $83fe5eb4ecf39302$var$btnLogin = document.querySelector(".login__btn");
const $83fe5eb4ecf39302$var$btnTransfer = document.querySelector(".form__btn--transfer");
const $83fe5eb4ecf39302$var$btnLoan = document.querySelector(".form__btn--loan");
const $83fe5eb4ecf39302$var$btnClose = document.querySelector(".form__btn--close");
const $83fe5eb4ecf39302$var$btnSort = document.querySelector(".btn--sort");
const $83fe5eb4ecf39302$var$inputLoginUsername = document.querySelector(".login__input--user");
const $83fe5eb4ecf39302$var$inputLoginPin = document.querySelector(".login__input--pin");
const $83fe5eb4ecf39302$var$inputTransferTo = document.querySelector(".form__input--to");
const $83fe5eb4ecf39302$var$inputTransferAmount = document.querySelector(".form__input--amount");
const $83fe5eb4ecf39302$var$inputLoanAmount = document.querySelector(".form__input--loan-amount");
const $83fe5eb4ecf39302$var$inputCloseUsername = document.querySelector(".form__input--user");
const $83fe5eb4ecf39302$var$inputClosePin = document.querySelector(".form__input--pin");
/////////////////////////////////////////////////
// Functions
const $83fe5eb4ecf39302$var$formatMovementDate = function(date, locale) {
    const calcDaysPassed = (date1, date2)=>Math.round(Math.abs(date2 - date1) / 86400000);
    const daysPassed = calcDaysPassed(new Date(), date);
    if (daysPassed === 0) return "Today";
    if (daysPassed === 1) return "Yesterday";
    if (daysPassed <= 7) return `${daysPassed} days ago`;
    // Debugging
    console.log(`Formatting date: ${date} for locale: ${locale}`);
    return new Intl.DateTimeFormat(locale).format(date);
};
// generic currency formatter
const $83fe5eb4ecf39302$var$formatCur = function(value, locale, currency) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(value);
};
const $83fe5eb4ecf39302$var$displayMovements = function(acc, sort = false) {
    console.log("Displaying movements");
    $83fe5eb4ecf39302$var$containerMovements.innerHTML = "";
    const movs = sort ? acc.movements.slice().sort((a, b)=>a - b) : acc.movements;
    movs.forEach(function(mov, i) {
        const type = mov > 0 ? "deposit" : "withdrawal";
        const date = new Date(acc.movementsDates[i]); // use current index to loop over other array (common technique)
        const displayDate = $83fe5eb4ecf39302$var$formatMovementDate(date, acc.locale);
        const formattedMov = $83fe5eb4ecf39302$var$formatCur(mov, acc.locale, acc.currency);
        // Debugging
        console.log(`Movement: ${mov}, Date: ${date}, Display Date: ${displayDate}`);
        const html = `
      <div class="movements__row">
        <div class="movements__type movements__type--${type}">${i + 1} ${type}</div>
        <div class="movements__date">${displayDate}</div>
        <div class="movements__value">${formattedMov}</div>
      </div>
    `;
        $83fe5eb4ecf39302$var$containerMovements.insertAdjacentHTML("afterbegin", html);
    });
};
const $83fe5eb4ecf39302$var$calcDisplayBalance = function(acc) {
    acc.balance = acc.movements.reduce((acc, mov)=>acc + mov, 0);
    $83fe5eb4ecf39302$var$labelBalance.textContent = $83fe5eb4ecf39302$var$formatCur(acc.balance, acc.locale, acc.currency);
};
const $83fe5eb4ecf39302$var$calcDisplaySummary = function(acc) {
    const incomes = acc.movements.filter((mov)=>mov > 0).reduce((acc, mov)=>acc + mov, 0);
    $83fe5eb4ecf39302$var$labelSumIn.textContent = $83fe5eb4ecf39302$var$formatCur(incomes, acc.locale, acc.currency);
    const out = acc.movements.filter((mov)=>mov < 0).reduce((acc, mov)=>acc + mov, 0);
    $83fe5eb4ecf39302$var$labelSumOut.textContent = $83fe5eb4ecf39302$var$formatCur(Math.abs(out), acc.locale, acc.currency);
    const interest = acc.movements.filter((mov)=>mov > 0).map((deposit)=>deposit * acc.interestRate / 100).filter((int, i, arr)=>{
        // console.log(arr);
        return int >= 1;
    }).reduce((acc, int)=>acc + int, 0);
    $83fe5eb4ecf39302$var$labelSumInterest.textContent = $83fe5eb4ecf39302$var$formatCur(interest, acc.locale, acc.currency);
};
const $83fe5eb4ecf39302$var$createUsernames = function(accs) {
    accs.forEach(function(acc) {
        acc.username = acc.owner.toLowerCase().split(" ").map((name)=>name[0]).join("");
    });
};
$83fe5eb4ecf39302$var$createUsernames($83fe5eb4ecf39302$var$accounts);
const $83fe5eb4ecf39302$var$updateUI = function(acc) {
    // Display movements
    $83fe5eb4ecf39302$var$displayMovements(acc);
    // Display balance
    $83fe5eb4ecf39302$var$calcDisplayBalance(acc);
    // Display summary
    $83fe5eb4ecf39302$var$calcDisplaySummary(acc);
};
const $83fe5eb4ecf39302$var$startLogOutTimer = function() {
    const tick = function() {
        const min = String(Math.trunc(time / 60)).padStart(2, 0);
        const sec = String(time % 60).padStart(2, 0);
        // Each callback call, print the remaining time to UI
        $83fe5eb4ecf39302$var$labelTimer.textContent = `${min}:${sec}`;
        // When 0 sec stop timer and log out user.
        if (time === 0) {
            clearInterval(timer);
            $83fe5eb4ecf39302$var$containerApp.style.opacity = 0;
            $83fe5eb4ecf39302$var$labelWelcome.textContent = `Log in to get started`;
        }
        // Decrease time
        time--;
    };
    // Set time to 5 mins
    let time = 120;
    // Call the timer every second
    tick();
    const timer = setInterval(tick, 1000);
    return timer; // we need this variable to be able to stop timer
};
///////////////////////////////////////
// Event handlers
let $83fe5eb4ecf39302$var$currentAccount, $83fe5eb4ecf39302$var$timer;
$83fe5eb4ecf39302$var$btnLogin.addEventListener("click", function(e) {
    console.log("Login button clicked");
    // Prevent form from submitting
    e.preventDefault();
    $83fe5eb4ecf39302$var$currentAccount = $83fe5eb4ecf39302$var$accounts.find((acc)=>acc.username === $83fe5eb4ecf39302$var$inputLoginUsername.value);
    if ($83fe5eb4ecf39302$var$currentAccount?.pin === +$83fe5eb4ecf39302$var$inputLoginPin.value) {
        // Display UI and message
        $83fe5eb4ecf39302$var$labelWelcome.textContent = `Welcome back, ${$83fe5eb4ecf39302$var$currentAccount.owner.split(" ")[0]}`;
        $83fe5eb4ecf39302$var$containerApp.style.opacity = 100;
        const now = new Date();
        const options = {
            hour: "numeric",
            minute: "numeric",
            day: "numeric",
            month: "numeric",
            year: "numeric"
        };
        // const locale = navigator.language;
        $83fe5eb4ecf39302$var$labelDate.textContent = new Intl.DateTimeFormat($83fe5eb4ecf39302$var$currentAccount.locale, options).format(now); // creates new formatter to which we call .format()
        // Clear input fields
        $83fe5eb4ecf39302$var$inputLoginUsername.value = $83fe5eb4ecf39302$var$inputLoginPin.value = "";
        $83fe5eb4ecf39302$var$inputLoginPin.blur();
        // Timer
        if ($83fe5eb4ecf39302$var$timer) clearInterval($83fe5eb4ecf39302$var$timer);
        $83fe5eb4ecf39302$var$timer = $83fe5eb4ecf39302$var$startLogOutTimer();
        // Update UI
        $83fe5eb4ecf39302$var$updateUI($83fe5eb4ecf39302$var$currentAccount);
    }
});
$83fe5eb4ecf39302$var$btnTransfer.addEventListener("click", function(e) {
    e.preventDefault();
    const amount = +$83fe5eb4ecf39302$var$inputTransferAmount.value;
    const receiverAcc = $83fe5eb4ecf39302$var$accounts.find((acc)=>acc.username === $83fe5eb4ecf39302$var$inputTransferTo.value);
    $83fe5eb4ecf39302$var$inputTransferAmount.value = $83fe5eb4ecf39302$var$inputTransferTo.value = "";
    if (amount > 0 && receiverAcc && $83fe5eb4ecf39302$var$currentAccount.balance >= amount && receiverAcc?.username !== $83fe5eb4ecf39302$var$currentAccount.username) {
        // Doing the transfer
        $83fe5eb4ecf39302$var$currentAccount.movements.push(-amount);
        receiverAcc.movements.push(amount);
        // Add transfer date
        $83fe5eb4ecf39302$var$currentAccount.movementsDates.push(new Date().toISOString());
        receiverAcc.movementsDates.push(new Date().toISOString());
        // Update UI
        $83fe5eb4ecf39302$var$updateUI($83fe5eb4ecf39302$var$currentAccount);
        // Reset timer
        clearInterval($83fe5eb4ecf39302$var$timer);
        $83fe5eb4ecf39302$var$timer = $83fe5eb4ecf39302$var$startLogOutTimer();
    }
});
$83fe5eb4ecf39302$var$btnLoan.addEventListener("click", function(e) {
    e.preventDefault();
    const amount = Math.floor($83fe5eb4ecf39302$var$inputLoanAmount.value);
    if (amount > 0 && $83fe5eb4ecf39302$var$currentAccount.movements.some((mov)=>mov >= amount * 0.1)) setTimeout(function() {
        // Add movement
        $83fe5eb4ecf39302$var$currentAccount.movements.push(amount);
        // Add loan date
        $83fe5eb4ecf39302$var$currentAccount.movementsDates.push(new Date().toISOString());
        // Update UI
        $83fe5eb4ecf39302$var$updateUI($83fe5eb4ecf39302$var$currentAccount);
        // Reset timer
        clearInterval($83fe5eb4ecf39302$var$timer);
        $83fe5eb4ecf39302$var$timer = $83fe5eb4ecf39302$var$startLogOutTimer();
    }, 2500);
    $83fe5eb4ecf39302$var$inputLoanAmount.value = "";
});
$83fe5eb4ecf39302$var$btnClose.addEventListener("click", function(e) {
    e.preventDefault();
    if ($83fe5eb4ecf39302$var$inputCloseUsername.value === $83fe5eb4ecf39302$var$currentAccount.username && +$83fe5eb4ecf39302$var$inputClosePin.value === $83fe5eb4ecf39302$var$currentAccount.pin) {
        const index = $83fe5eb4ecf39302$var$accounts.findIndex((acc)=>acc.username === $83fe5eb4ecf39302$var$currentAccount.username);
        // Delete account
        $83fe5eb4ecf39302$var$accounts.splice(index, 1);
        // Hide UI
        $83fe5eb4ecf39302$var$containerApp.style.opacity = 0;
    }
    $83fe5eb4ecf39302$var$inputCloseUsername.value = $83fe5eb4ecf39302$var$inputClosePin.value = "";
});
let $83fe5eb4ecf39302$var$sorted = false;
$83fe5eb4ecf39302$var$btnSort.addEventListener("click", function(e) {
    e.preventDefault();
    $83fe5eb4ecf39302$var$displayMovements($83fe5eb4ecf39302$var$currentAccount, !$83fe5eb4ecf39302$var$sorted);
    $83fe5eb4ecf39302$var$sorted = !$83fe5eb4ecf39302$var$sorted;
});

})();
//# sourceMappingURL=login.c2d92b54.js.map
